import {
  getDmUnread,
  getGrocery,
  getLastBoards,
  getLatestSystemDM,
  getUnreadNum,
  getUserCount,
} from "@/services";

export default function app(set, get) {
  return {
    envInfo: {
      env: process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod",
      isCanary: false,
    },
    isPageCache: false,
    categories: [],
    pinQueue: [],
    currentPin: null,
    /** 全屏详情页弹窗堆栈，最多保留 MAX_PIN_STACK_SIZE 个 */
    pinStack: [],
    currentPreview: {},
    isMobile: false,
    ads: null,
    /**指定页面吸顶广告信息配置 */
    adTopConfig: null,
    /** 杂货铺来源字典数据*/
    /** 当前弹出折叠对象 */
    currentFold: null,
    /** 杂货铺来源字典数据 */
    domains: [],
    globalNotice: null,

    aiLinkMap: [], // ai创作工具列表

    unreadNum: 0,
    dmUnread: null,
    latestSystemDM: null,
    /** 用户所有画板，不带封面信息 */
    lastBoards: [],
    lastBoardsReady: false,
    /** 用户采集的图片数量 */
    pinCount: 0,
    /** 远端/用户基础采集数（首屏或限流刷新写入，不影响原有 pinCount） */
    basePinCount: 0,
    /** 基础采集数最近一次成功拉取时间戳（ms） */
    basePinCountFetchedAt: 0,
    /** 基础采集数是否正在拉取，避免并发 */
    isFetchingBasePinCount: false,
    /** 本地会话增量采集数（新增字段，不影响原有 pinCount） */
    deltaPinCount: 0,
    /** 更新当前用户画板 */
    async refreshLastBoards() {
      const { boards, err } = await getLastBoards();
      if (err) return;
      set({
        lastBoards: Array.isArray(boards) ? boards : [],
        lastBoardsReady: true,
      });
      return Array.isArray(boards) ? boards : [];
    },
    setLastBoards(boards) {
      set({
        lastBoards: Array.isArray(boards) ? boards : [],
      });
    },
    /** 更新用户采集数量 */
    setPinCount(count) {
      set({
        pinCount: count,
      });
    },
    /** 增加用户采集数量 */
    incrementPinCount() {
      set((state) => ({
        pinCount: state.pinCount + 1,
      }));
    },
    /** 设置基础采集数（不影响原有 pinCount 的增量语义） */
    setBasePinCount(count) {
      set({
        basePinCount: Math.max(0, Number(count) || 0),
        basePinCountFetchedAt: Date.now(),
      });
    },
    /** 本地增量 +1（新增方法） */
    incrementPinDelta() {
      set((state) => ({
        deltaPinCount: (state.deltaPinCount || 0) + 1,
      }));
    },
    /** 重置本地增量（在远端刷新或用户切换时可用） */
    resetPinDelta() {
      set({ deltaPinCount: 0 });
    },
    /**
     * 限流刷新远端采集数：
     * - 需存在 user.urlname
     * - 5 分钟内仅刷新一次
     * - 避免并发
     */
    async refreshRemotePinCountOnce() {
      const state = get();
      const urlname = state?.user?.urlname;
      if (!urlname) return;
      const TTL = 5 * 60 * 1000;
      if (state.isFetchingBasePinCount) return;
      if (Date.now() - (state.basePinCountFetchedAt || 0) < TTL) return;
      set({ isFetchingBasePinCount: true });
      try {
        const res = await getUserCount({ urlname });
        const remote = res?.user_counts?.pin_count || 0;
        set({
          basePinCount: Math.max(state.basePinCount || 0, remote || 0),
          basePinCountFetchedAt: Date.now(),
          // 远端基线刷新后，本地增量清零，避免重复累计
          deltaPinCount: 0,
        });
      } catch (e) {
        // ignore
      } finally {
        set({ isFetchingBasePinCount: false });
      }
    },
    // 获取未读私信消息数量
    async refreshDmUnread() {
      const result = await getDmUnread();
      if (result.err) return;

      const prevUnread = get()?.dmUnread;
      // 有新的系统消息时，获取最新的系统消息
      if (
        +result?.unread_system_dm &&
        result?.unread_system_dm !== prevUnread?.unread_system_dm
      ) {
        const systemDM = await getLatestSystemDM();
        if (!systemDM.err) {
          set({
            dmUnread: result,
            latestSystemDM: systemDM,
          });
        }
      } else {
        set({
          dmUnread: result,
        });
      }
    },
    // 获取消息消息数量
    async refreshUnreadMsg() {
      const result = await getUnreadNum();
      if (result.err) return;
      set({
        unreadNum: result,
      });
    },
    // sucaiIsRead: false,
    // 应用全局配置 配置地址： https://grocery.huaban.com/put/6
    config: null,
    async getAppConfig() {
      const data = await getGrocery("global-config");
      set({
        config: data || {},
      });
    },
    // banner可见性状态
    globalBannerVisible: false,
    setGlobalBannerVisible(visible) {
      set({
        globalBannerVisible: Boolean(visible),
      });
    },
    /** 添加 pin 到堆栈顶部 */
    pushPinToStack(pinData) {
      const currentStack = get().pinStack;
      // 先添加新的到堆栈
      let newStack = [...currentStack, { ...pinData, _timestamp: Date.now() }];

      set({
        pinStack: newStack,
        currentPin: pinData, // 保持向后兼容
      });

      // 返回新元素在 newStack 中的索引（永远是最后一个，因为刚添加的）
      return {
        index: newStack.length - 1,
      };
    },
    /** 从堆栈顶部移除 pin */
    popPinFromStack() {
      const currentStack = get().pinStack;

      if (currentStack.length === 0) {
        return null;
      }

      const newStack = currentStack.slice(0, -1);
      const currentPin =
        newStack.length > 0 ? newStack[newStack.length - 1] : null;

      set({
        pinStack: newStack,
        currentPin, // 保持向后兼容
      });

      return currentPin;
    },
    /** 清空整个堆栈 */
    clearPinStack() {
      set({
        pinStack: [],
        currentPin: null,
      });
    },
    /** 设置堆栈到指定索引（用于浏览器后退） */
    setPinStackToIndex(index) {
      const currentStack = get().pinStack;
      if (index < 0) {
        set({
          pinStack: [],
          currentPin: null,
        });
        return;
      }

      const newStack = currentStack.slice(0, index + 1);
      const currentPin =
        newStack.length > 0 ? newStack[newStack.length - 1] : null;

      set({
        pinStack: newStack,
        currentPin,
      });
    },
    /** 更新堆栈中指定索引的滚动位置 */
    updatePinStackScrollTop(index, scrollTop) {
      const currentStack = get().pinStack;
      if (index >= 0 && index < currentStack.length) {
        const newStack = [...currentStack];
        newStack[index] = { ...newStack[index], scrollTop };
        set({
          pinStack: newStack,
        });
      }
    },
    /** 更新当前弹窗的数据（用于左右切换） */
    updateCurrentPinInStack(pinData) {
      const currentStack = get().pinStack;
      if (currentStack.length > 0) {
        const newStack = [...currentStack];
        const lastIndex = newStack.length - 1;
        newStack[lastIndex] = {
          ...newStack[lastIndex],
          ...pinData,
          _timestamp: Date.now(),
        };
        set({
          pinStack: newStack,
          currentPin: pinData, // 保持向后兼容
        });
      }
    },

    /** 防刷限制：记录上次切换时间 */
    lastSwitchTime: 0,
    SWITCH_COOLDOWN: 1000, // 2秒防刷限制

    /** 检查是否可以切换（防刷限制） */
    canSwitch() {
      const now = Date.now();
      const { lastSwitchTime, SWITCH_COOLDOWN } = get();
      if (now - lastSwitchTime < SWITCH_COOLDOWN) {
        return false; // 如果距离上次切换不足2秒，则不允许切换
      }
      set({ lastSwitchTime: now });
      return true;
    },
  };
}

// 顶部 banner 高度
export const selectGlobalBannerHeight = (state) => {
  return state.globalBannerVisible ? 60 : 0;
};
